export const VOP_RESULTS = {
  MATCH: "MATCH",
  NO_MATCH: "NO_MATCH",
  CLOSE_MATCH: "CLOSE_MATCH",
  ERROR: "ERROR",
} as const;

export const VOP_STATUS = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  PENDING: "PENDING",
} as const;
